export default __webpack_public_path__ + "static/media/green_slider.605f8f79.svg";